/**
 * Copyright © 2026 Adnuntius AS.
 */
export function formatNoteData(data: string | string[] | null | undefined): string {
  if (Array.isArray(data)) {
    return data.join('');
  }
  return data || '';
}

export function isEmptyNoteHtml(value: string | null | undefined): boolean {
  if (!value) {
    return true;
  }
  const stripped = value.replace(/<[^>]+>/g, '').replace(/&nbsp;/g, ' ').trim();
  return stripped.length === 0;
}
